import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Await } from "react-router-dom";
import { SystemMailWithoutBody } from "../../model/SystemMail";
import { Customer } from "../../model/Customer";
import { useCopySystemMailDialog } from "../../hooks/useCopySystemMailDialog";
import SystemMailTemplateTable from "./SystemMailTemplateTable";
import classes from "../../styling/pages/Manager.module.css";

interface Props {
    templates: Promise<SystemMailWithoutBody[]>;
    customers: Customer[];
}

export const AdminSystemMailTemplateOverview: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { customerId } = useParams<{ customerId: string }>();
    const [selectedTemplateIds, setSelectedTemplateIds] = useState<string[]>([]);
    const [copyDialog, openCopyDialog] = useCopySystemMailDialog();

    const handleOpenCopyDialog = () => {
        openCopyDialog(handleCopyResult, customerId!, selectedTemplateIds, props.customers);
    };

    const handleCopyResult = (_data: SystemMailWithoutBody[], _targetCustomerId: string) => {
        // Optionally refresh or navigate; same as template overview
    };

    return (
        <>
            <Box className={classes.buttonContainer}>
                <Link to="new">
                    <Button variant="contained">
                        {t("systemMailTemplate.manager.newTemplate")}
                    </Button>
                </Link>
                <Button
                    variant="contained"
                    disabled={selectedTemplateIds.length === 0}
                    onClick={handleOpenCopyDialog}
                    sx={{ ml: 1 }}
                >
                    {t("templateTable.copyTemplates")}
                </Button>
                {copyDialog}
            </Box>
            <Await resolve={props.templates}>
                {(loadedTemplates) => (
                    <SystemMailTemplateTable
                        templates={loadedTemplates}
                        selectedTemplateIds={selectedTemplateIds}
                        onSelectionChange={setSelectedTemplateIds}
                        readonly={false}
                    />
                )}
            </Await>
        </>
    );
};
